import { makeHttpRequest } from "@/shared";

import { mapCalculatedRentFromServer } from "./mappers/mapCalculatedRentFromServer";
import { mapPaymentRentToServer } from "./mappers/mapPaymentRentToServer";

export const removePaymentFromRent = async (sessionKey, payment) => {
    const response = (
        await makeHttpRequest({
            url: `/rent/builder/${sessionKey}/remove/payment`,
            method: "DELETE",
            data: mapPaymentRentToServer(payment),
        })
    ).data;

    return mapCalculatedRentFromServer(response.data);
};
